import { useMemo } from 'react';
import { useAuth } from '@/auth/AuthContext';
import type { UserSimpleUidType } from '@/types/types_user';

/**
 * The signed-in user, in the denormalised shape stamped onto history steps.
 * One code path for both audiences: an Eighty Days admin and a partner
 * are both just a Firebase Auth user here, and the history step records which
 * of them made the change.
 */
export function useCurrentUserSimple(): UserSimpleUidType {
  const { user } = useAuth();
  const uid = user?.uid;
  const email = user?.email;
  const displayName = user?.displayName;

  return useMemo(
    () => ({
      uid: uid ?? '',
      email: email ?? '',
      name: displayName || email || 'Unknown user',
    }),
    [uid, email, displayName],
  );
}
